/**
 * 消息传递器, 根据Vue本身再进行扩展
 */

import Vue from 'vue'

export default class EventBus {
  constructor () {
    let eventBus = new Vue()

    this.emit = (eventName, ...args) => {
      eventBus.$emit(eventName, ...args)
    }

    this.on = (eventName, handler) => {
      eventBus.$on(eventName, handler)
    }

    this.once = (eventName, handler) => {
      eventBus.$once(eventName, handler)
    }

    this.off = (eventName, handler) => {
      eventBus.$off(eventName, handler)
    }

    this.destroy = () => {
      for (let key in this) {
        this[key] = null
      }

      eventBus = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/EventBus.js